module.exports = __webpack_public_path__ + "static/media/sportAvatar__dota2.8380c993.jpg";